import { InviewAnim } from "../utils/animations"

export const AboutComponent = () => {
    return (
        <div className="about-container">
            <InviewAnim inView={'slide-up-after'} notInView={'slide-up-before'}>
                <div className="about-unit">
                    <img src="/svgs/express-delivery.svg" alt="" className="about-image" />
                    <div className="about-caption">FAST DELIVERY</div>
                    <p className="about-info">
                        We deliver within 3 hours in Douala, and within 24 hours to other cities.
                    </p>
                </div>
            </InviewAnim>
            
            <InviewAnim inView={'slide-up-after'} notInView={'slide-up-before'}>
                <div className="about-unit">
                    <img src="/svgs/delivery.svg" alt="" className="about-image" />
                    <div className="about-caption">PAYMENT ON DELIVERY</div>
                    <p className="about-info">
                        Payment is upon delivery, using either cash, mobile money or orange money.
                    </p>
                </div>
            </InviewAnim>

            <InviewAnim inView={'slide-up-after'} notInView={'slide-up-before'}>
                <div className="about-unit">
                    <img src="/svgs/package-return.svg" alt="" className="about-image" />
                    <div className="about-caption">EASY AND FAST RETURN</div>
                    <p className="about-info">
                        We accept returns of goods within seven days of delivery.
                    </p>
                </div>
            </InviewAnim>

            <InviewAnim inView={'slide-up-after'} notInView={'slide-up-before'}>
                <div className="about-unit">
                    <img src="/svgs/customer-service.svg" alt="" className="about-image" />
                    <div className="about-caption">24/7 CUSTOMER SERVICE</div>
                    <p className="about-info">
                        We are always available to help customers, to attend to their worries and answer their questions.
                    </p>
                </div>
            </InviewAnim>
        </div>
    )
}